import * as React from "react"
const SvgComponent = (props: React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="none"
    {...props}
  >
    <g stroke="#344054" strokeWidth={1.5} clipPath="url(#a)">
      <path
        strokeLinejoin="round"
        d="m13.7 17.79.46-.575c.405-.506 1.264-.465 1.605.076.411.65 1.426.52 1.707-.078.015-.03-.021.047.01-.222.031-.27.018-.33-.008-.454L15.87 8.97c-.402-1.902-.604-2.853-1.296-3.411C13.882 5 12.904 5 10.949 5H9.05c-1.955 0-2.933 0-3.625.559-.693.558-.895 1.51-1.297 3.411l-1.603 7.567c-.026.123-.039.185-.008.454.032.27-.005.191.01.223.281.598 1.296.727 1.707.077.341-.541 1.2-.582 1.604-.076l.46.575c.58.725 1.791.725 2.371 0l.072-.09c.616-.77 1.9-.77 2.516 0l.072.09c.58.725 1.79.725 2.37 0Z"
      />
      <path
        strokeLinecap="round"
        d="M2.07 7.916c-.487-.507-.395-1.16-.395-2.79 0-1.631 0-2.447.488-2.953.487-.507 1.272-.507 2.842-.507h9.992c1.57 0 2.355 0 2.843.507.488.506.488 1.322.488 2.953 0 1.63.091 2.283-.397 2.79"
      />
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M10 8.332H7.5M11.668 11.666h-5"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h20v20H0z" />
      </clipPath>
    </defs>
  </svg>
)
export default SvgComponent
